export default {
      id: "marquise-usage",
      viewBox: "0 0 19 30",
      url: __webpack_public_path__ + "icons.svg#marquise",
      toString: function () {
        return this.url;
      }
    }